import { createFileRoute } from '@tanstack/react-router';
import { ChecklistOnboardingPage } from '@/components/onboarding';

export const Route = createFileRoute('/_app/configuracoes/onboarding')({
  component: OnboardingConfigRota,
});

function OnboardingConfigRota() {
  return <ChecklistOnboardingPage />;
}
